
import { computed, defineComponent } from 'vue'
import type { PropType } from 'vue'
import { PermissionMap, UserInterface } from '@/models/users/User.interface'
import { humanizeFeatureKey } from '@/utils/featureKey'

export default defineComponent({
  props: {
    user: { type: Object as PropType<UserInterface>, required: true }
  },
  setup(props) {
    const permissions = computed<PermissionMap>(
      () => props.user.permissions ?? {}
    )
    return { permissions, humanizeFeatureKey }
  }
})
